import { Component, Input } from '@angular/core';
import { ModelDialogType } from '../../models/menu';
import { DialogService } from '../../providers/dialogservice';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialogbox.component.html',
  styleUrls: ['./dialogbox.component.css']
})

export class DialogComponent {
  @Input() dialogInput: ModelDialogType; // used to get the inputs from the user(providers)

  close() {
    this.dialogInput.visible = false;
  }
}
